import { defineInlineEdit } from "../../../../components/MobileList/inlineEdit";
import { SelectExpenseTypes } from "../../../../components/Selectors/SelectExpensType";

/**
 * views/expense/from submits the whole form object, which getById fills as
 * `{id, spending_type_id, amount, date, note}` — the list row instead carries a
 * nested `spending_type` object, so the detail is fetched before the PUT.
 *
 * `amount` is deliberately NOT editable: the form renders it `disabled={!isAdd}`,
 * so it is create-only.
 */
export default defineInlineEdit({
  api: "expense",
  permission: "spending_edit",
  hydrate: true,
  toPayload: (detail) => ({
    id: detail.id,
    spending_type_id: detail.spending_type_id ?? detail.spending_type?.id,
    amount: detail.amount,
    date: detail.date,
    note: detail.note ?? "",
  }),
  fields: {
    spending_type: {
      label: "نوع المصاريف",
      type: "select",
      component: SelectExpenseTypes,
      required: true,
      // The row's nested object is already `{id, name}` — exactly what the
      // Autocomplete wants, so no extra fetch just to open the editor.
      getValue: (source, row) => row?.spending_type ?? null,
      toPatch: (value) => ({ spending_type_id: value?.id ?? null }),
    },
    date: { label: "التاريخ", type: "date", required: true },
    note: { label: "الملاحظة", type: "multiline", required: true },
  },
});
